import { useState, useEffect } from 'react';
import { loadDemoStatuses } from '../demo/demoData';

function useOldProtocolsStatuses() {
  const [oldProtocolsStatuses, setOldProtocolsStatuses] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchStatuses = async () => {
    try {
      const data = await loadDemoStatuses('oldprotocols');
      setOldProtocolsStatuses(data || {});
    } catch (err) {
      setError('Failed to fetch old protocols statuses: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatuses();
  }, []);

  const updateStatus = async (oldProtocolName, enabled) => {
    setLoading(true);
    try {
      setOldProtocolsStatuses(prev => ({
        ...prev,
        [oldProtocolName]: { ...(prev[oldProtocolName] || {}), enabled }
      }));
      return true;
    } catch (err) {
      setError(`Failed to ${enabled ? 'enable' : 'disable'} ${oldProtocolName}: ${err.message}`);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { 
    oldProtocolsStatuses,
    loading, 
    error, 
    updateStatus,
    refreshStatuses: fetchStatuses 
  };
}

export default useOldProtocolsStatuses; 